import { useLocale } from '@/lib/i18n';
import type { Locale } from '@/lib/i18n';

export function useSectionTranslation<T>(translations: Record<Locale, T>): T {
  const { locale } = useLocale();
  return translations[locale];
}
